import Iframe from "./Iframe"
function App() {
  return (<>
  <Iframe/>
  </>);
}

export default App;
